/**
 * Show feedback for the user inside input boxes of form.
 *
 * @param type
 * @param result
 */
function mas_form_infinity_message_input(type = '', result = '') {
	result.removeClass( 'forms__result--success' )
		.removeClass( 'forms__result--error' )
		.removeClass( 'forms__result--info' );
	let iconType;

	switch (type) {
		case 'success':
			iconType = 'icon-general-success';
			result.addClass( 'forms__result--success' );
			break;
		case 'error':
			iconType = 'icon-general-fail';
			result.addClass( 'forms__result--error' );
			break;
		default:
			iconType = 'icon-general-info-black';
			result.addClass( 'forms__result--info' );
			break;
	}
	const icon = jQuery( '<i>', { class: iconType } );
	result.empty().append( icon );
}

/**
 * Clears div classes and empties them.
 */
function mas_form_infinity_message_general_clean() {
	const result = jQuery( '.forms__common-result' );
	result.removeClass( 'forms__common-result--success' )
		.removeClass( 'forms__common-result--error' )
		.removeClass( 'forms__common-result--info' )
		.empty();
}

/**
 * Show feedback of general errors for the user in a text box.
 *
 * @param message
 * @param type
 */
function mas_form_infinity_message_general(message = '', type = '') {
	const result    = jQuery( '#masInfinityResult' );
	const paragraph = jQuery( '<p>', { text: message } );

	/**
	 * Builder result section
	 */
	let iconType;

	switch (type) {
		case 'success':
			iconType = 'icon-general-success';
			result.addClass( 'forms__common-result--success' );
			paragraph.addClass( 'js-form-success' );
			break;
		case 'error':
			iconType = 'icon-general-fail';
			result.addClass( 'forms__common-result--error' );
			paragraph.addClass( 'js-form-error' );
			break;
		default:
			iconType = 'icon-general-info-black';
			result.addClass( 'forms__common-result--info' );
			paragraph.addClass( 'js-form-info' );
			break;
	}

	const icon = jQuery( '<i>', { class: iconType } );

	mas_form_infinity_message_general_clean();
	result.append( icon, paragraph );
}

/**
 * Disable submit form button.
 */
function mas_form_infinity_submit_disabled() {
	jQuery( '#masInfinitySubmit' ).prop( "disabled", true );
}

/**
 * Enable submit form button.
 */
function mas_form_infinity_submit_enabled() {
	jQuery( '#masInfinitySubmit' ).prop( "disabled", false );
}

/**
 * Reset form fields and feedback icon.
 */
function mas_form_infinity_reset() {
	jQuery( '#masInfinity' ).trigger( "reset" );
	jQuery( '.forms__result' ).empty();
}

/**
 * Send form to custom infinity ajax action.
 *
 * @param nif
 * @param company
 * @param person
 * @param phone
 * @param email
 * @param zip
 * @param url
 * @param time
 * @param nonce
 * @param infinity
 * @param token
 * @param checkbox
 */
function mas_form_infinity_send(
	nif,
	company,
	person,
	phone,
	email,
	zip,
	url,
	time,
	nonce,
	infinity,
	token,
	checkbox
) {
	let myRequestURL = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();
	jQuery.ajax(
		{
			type: "POST",
			url: myRequestURL,
			data: {
				'action': 'mas_form_infinity',
				'data': {
					'nif': nif.val(),
					'company': company.val(),
					'person': person.val(),
					'phone': phone.val(),
					'email': email.val(),
					'zip': zip.val(),
					'url': url.val(),
					'time': time.val(),
					'nonce': nonce.val(),
					'infinity': infinity.val(),
					'token': token,
					'checkbox': checkbox.is( ":checked" )
				}
			},
			dataType: 'json',
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				mas_form_infinity_submit_disabled();
				mas_form_infinity_message_general(
					'Estamos procesando su solicitud. Por favor, espere. ' +
					'Puede tardar varios segundos.'
				);
			},
			success: function (data, textStatus, jqXHR) {
				mas_form_infinity_submit_enabled();
				mas_form_infinity_reset();
				if (200 !== jqXHR.status) {
					return;
				}
				mas_form_infinity_message_general( data.message, 'success' );
			},
			error: function (jqXHR) {
				mas_form_infinity_submit_enabled();
				mas_form_infinity_reset();
				const response = JSON.parse( jqXHR.responseText );
				mas_form_infinity_message_general( response.message, 'error' );
			}
		}
	);
}

/**
 * Validate specific fields before sending.
 *
 * @param nif
 * @param company
 * @param person
 * @param phone
 * @param email
 * @param zip
 * @param url
 *
 * @returns {boolean}
 */
function mas_form_infinity_validate(
	nif,
	company,
	person,
	phone,
	email,
	zip,
	url
) {
	let isError = false;

	/**
	 * NIF field validation
	 */
	const domResultNif = jQuery( '.forms__result[data-field="' + nif.attr( "id" ) + '"]' );
	if (9 !== nif.val().length) {
		mas_form_infinity_message_input( 'error', domResultNif );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultNif );
	}

	/**
	 * COMPANY field validation
	 */
	const domResultCompany = jQuery( '.forms__result[data-field="' + company.attr( "id" ) + '"]' );
	if (0 === company.val().length) {
		mas_form_infinity_message_input( 'error', domResultCompany );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultCompany );
	}

	/**
	 * PERSON field validation
	 */
	const domResultPerson = jQuery( '.forms__result[data-field="' + person.attr( "id" ) + '"]' );
	if (0 === person.val().length) {
		mas_form_infinity_message_input( 'error', domResultPerson );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultPerson );
	}

	/**
	 * PHONE field validation
	 */
	const domResultPhone = jQuery( '.forms__result[data-field="' + phone.attr( "id" ) + '"]' );
	if ( ! (/^\d{9}$/.test( phone.val() ))) {
		mas_form_infinity_message_input( 'error', domResultPhone );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultPhone );
	}

	/**
	 * EMAIL field validation
	 */
	const domResultEmail = jQuery( '.forms__result[data-field="' + email.attr( "id" ) + '"]' );
	if ( ! (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test( email.val() ))) {
		mas_form_infinity_message_input( 'error', domResultEmail );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultEmail );
	}

	/**
	 * ZIP field validation
	 */
	const domResultZip = jQuery( '.forms__result[data-field="' + zip.attr( "id" ) + '"]' );
	if (0 === zip.val().length) {
		mas_form_infinity_message_input( 'error', domResultZip );
		isError = true;
	} else {
		mas_form_infinity_message_input( 'success', domResultZip );
	}

	/**
	 * URL field validation
	 */
	const domResultUrl = jQuery( '.forms__result[data-field="' + url.attr( "id" ) + '"]' );
	if (0 === url.val().length) {
		mas_form_infinity_message_input( "error", domResultUrl );
		isError = true;
	} else {
		mas_form_infinity_message_input( "success", domResultUrl );
	}

	return true !== isError;
}

/**
 * Validate security fields before sending.
 *
 * @param time
 * @param nonce
 * @param infinity
 *
 * @returns {boolean}
 */
function mas_form_infinity_validate_security(time, nonce, infinity) {
	if (0 === time.val().length) {
		return false;
	}
	if (0 === nonce.val().length) {
		return false;
	}
	if (0 < infinity.val().length) {
		return false;
	}

	return true;
}

/**
 * Validate checkbox field before sending.
 *
 * @param checkbox
 *
 * @returns {boolean}
 */
function mas_form_infinity_validate_checkbox(checkbox) {
	if (false === checkbox.is( ":checked" )) {
		return false;
	}

	return true;
}

/**
 * Handle submit custom infinity form.
 */
function mas_form_infinity_initialize() {
	const form = jQuery( '#masInfinity' );
	form.on(
		'submit',
		function (event) {
			event.preventDefault();

			const nif      = jQuery( '#masInfinityNif' );
			const company  = jQuery( '#masInfinityCompany' );
			const person   = jQuery( '#masInfinityContactPerson' );
			const phone    = jQuery( '#masInfinityPhone' );
			const email    = jQuery( '#masInfinityEmail' );
			const zip	   = jQuery( '#masInfinityZip' );
			const url	   = jQuery( '#masInfinityUrl' );
			const time     = jQuery( '#masInfinityTime' );
			const nonce    = jQuery( '#masInfinityNonce' );
			const infinity = jQuery( '#masInfinity' );
			const key      = jQuery( '#masFormPublicKey' );
			const checkbox = jQuery( '#masInfinityLegalCheckbox' );

			if (false === mas_form_infinity_validate(
				nif,
				company,
				person,
				phone,
				email,
				zip,
				url
			)) {
				mas_form_infinity_message_general(
					'¡Ups! Revise alguno de los campos.',
					'error'
				);
				return false;
			}

			if (false === mas_form_infinity_validate_security(
				time,
				nonce,
				infinity
			)) {
				mas_form_infinity_message_general(
					'¡Ups! Algo no ha ido bien. Refresque la página y pruebe de nuevo.',
					'error'
				);
				return false;
			}

			if (false === mas_form_infinity_validate_checkbox( checkbox )) {
				mas_form_infinity_message_general(
					'¡Ups! Acepte la casilla de la política de privacidad.',
					'error'
				);
				return false;
			}

			grecaptcha.ready(
				function () {
					grecaptcha.execute( key.val(), { action: 'submit' } ).then(
						function (token) {
							if (0 === token.length) {
								mas_form_infinity_message_general(
									'¡Ups! Algo no ha ido bien.' +
									' Refresque la página y pruebe de nuevo.',
									'error'
								);
								return false;
							}

							mas_form_infinity_send(
								nif,
								company,
								person,
								phone,
								email,
								zip,
								url,
								time,
								nonce,
								infinity,
								token,
								checkbox
							);

							return true;
						}
					);
				}
			);

			return true;
		}
	);
}

(function ($) {
	$( document ).ready(
		function () {
			mas_form_infinity_initialize();
		}
	);
})( jQuery );
